module.exports = __webpack_public_path__ + "static/media/lastfm.e4b8398d.svg";